'use client';

import * as Sentry from '@sentry/nextjs';
import NextError from 'next/error';
import { use, useEffect } from 'react';
export default function GlobalError(props: {
  error: Error & {
    digest?: string;
  };
  params?: Promise<{
    locale?: string;
  }>;
}) {
  useEffect(() => {
    const digest = props.error.digest ?? 'unknown';
    const isServerError = !!props.error.digest;
    if (isServerError) {
      Sentry.captureMessage(`🧯 GlobalError triggered. Digest: ${digest}`, 'error');
    } else {
      Sentry.captureException(props.error, {
        tags: {
          component: 'GlobalError'
        }
      });
    }
  }, [props.error]);
  const locale = use(props.params ?? Promise.resolve({
    locale: 'en'
  })).locale;
  return <html lang={locale} data-sentry-component="GlobalError" data-sentry-source-file="global-error.tsx">
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
         definition requires a `statusCode` prop. However, since the App Router
         does not expose status codes for errors, we simply pass 0 to render a
         generic error message. */}
        {props.error.digest && <p className="text-sm text-muted-foreground">Error ID: {props.error.digest}</p>}
        <NextError statusCode={0} data-sentry-element="NextError" data-sentry-source-file="global-error.tsx" />
      </body>
    </html>;
}